import {useRestaurants} from 'api/queries';
import {ProviderSliderWithSkeleton, ProviderTileList, Section} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC} from 'react';
import {ICustomerAddToFavoritesRequest, ICustomerMyFavoritesResponse, QueryKeyEnum} from 'types';

interface IProps {
  locale: string;
  myFavorite: ICustomerMyFavoritesResponse[];
  onEditFavorite: (data: ICustomerAddToFavoritesRequest) => void;
  coordinates: string;
}

export const RecomendedSection: FC<IProps> = ({locale, myFavorite, onEditFavorite, coordinates}) => {
  const {t} = useTranslation();

  const {data: recomendedRestaurants, isLoading: isLoadingRecomendedRestaurants} = useRestaurants(
    [QueryKeyEnum.RESTAURANT_BY_FILTER, {filters: 'top'}, locale, coordinates],
    {
      limit: 0,
      filters: 'top',
      only_working: true,
      ordering: 'distance',
    },
    {},
  );

  const isShowBlock = !!recomendedRestaurants?.count || isLoadingRecomendedRestaurants;

  return (
    <>
      {isShowBlock && (
        <Section
          title={t('RECOMMENDED_RESTAURANTS')}
          viewAllLabel={t('VIEW_ALL')}
          linkTo="/restaurants?filters=top&ordering=distance"
          count={`${recomendedRestaurants?.count ?? ''}`}
        >
          <ProviderSliderWithSkeleton conditionValue={isLoadingRecomendedRestaurants}>
            <ProviderTileList
              myFavorite={myFavorite}
              onEditFavorite={onEditFavorite}
              data={recomendedRestaurants?.results}
              isHorizontal
            />
          </ProviderSliderWithSkeleton>
        </Section>
      )}
    </>
  );
};
